import { Controller } from '@hotwired/stimulus'
import EditorJS from '@editorjs/editorjs'
import Image from '@editorjs/image'
import Underline from '@editorjs/underline'
import DragDrop from 'editorjs-drag-drop'
import CustomHeader from '../../lib/editorjs-plugins/custom-header'
import CustomList from '../../lib/editorjs-plugins/custom-list'
import LinkButton from '../../lib/editorjs-plugins/link-button'
import RecommendedArticles from '../../lib/editorjs-plugins/recommend-articles'
import { i18nData } from '../../lib/editorjs-i18n'

export default class extends Controller {
  static targets = ['form', 'leadTextEditor', 'leadTextHidden', 'contentEditor', 'contentHidden']

  connect() {
    this.leadTextEditor = new EditorJS({
      holder: this.leadTextEditorTarget,
      tools: {
        list: {
          class: CustomList,
          inlineToolbar: true,
          config: {
            counterTypes: ['numeric']
          },
          toolbox: [
            {
              data: { style: 'unordered' },
            },
            {
              data: { style: 'ordered' },
            },
          ],
        },
        image: {
          class: Image,
          config: {
            endpoints: {
              byFile: '/admin/articles/upload_image',
            },
            additionalRequestHeaders: {
              'X-CSRF-Token': this.csrfToken(),
            },
            features: {
              background: false,
              border: false,
              caption: false,
              stretch: false,
            },
          },
        },
        underline: Underline,
      },
      onReady: () => {
        new DragDrop(this.leadTextEditor);
      },
      data: this.leadTextHiddenTarget.value ? JSON.parse(this.leadTextHiddenTarget.value) : {},
      i18n: i18nData,
      minHeight: 80,
    })

    this.contentEditor = new EditorJS({
      holder: this.contentEditorTarget,
      tools: {
        header: {
          class: CustomHeader,
          config: {
            levels: [2, 3, 4],
            defaultLevel: 2,
          },
        },
        list: {
          class: CustomList,
          inlineToolbar: true,
          config: {
            counterTypes: ['numeric']
          },
          toolbox: [
            {
              data: { style: 'unordered' },
            },
            {
              data: { style: 'ordered' },
            },
          ],
        },
        image: {
          class: Image,
          config: {
            endpoints: {
              byFile: '/admin/articles/upload_image',
            },
            additionalRequestHeaders: {
              'X-CSRF-Token': this.csrfToken(),
            },
            features: {
              background: false,
              border: false,
              caption: false,
              stretch: false,
            },
          },
        },
        underline: Underline,
        linkButton: LinkButton,
        recommendedArticles: RecommendedArticles,
      },
      onReady: () => {
        new DragDrop(this.contentEditor);
      },
      data: this.contentHiddenTarget.value ? JSON.parse(this.contentHiddenTarget.value) : {},
      i18n: i18nData,
      minHeight: 80,
    })

    this.formSubmitEventListener = this.saveAndSubmit.bind(this)
    this.formTarget.addEventListener('submit', this.formSubmitEventListener)
  }

  disconnect() {
    this.formTarget.removeEventListener('submit', this.formSubmitEventListener)
    this.formSubmitEventListener = null
    this.contentEditor.destroy()
    this.contentEditor = null
  }

  async saveAndSubmit(event) {
    event.preventDefault()

    const [leadTextData, contentData] = await Promise.all([
      this.leadTextEditor.save(),
      this.contentEditor.save()
    ])
    this.leadTextHiddenTarget.value = JSON.stringify(leadTextData)
    this.contentHiddenTarget.value = JSON.stringify(contentData)

    this.formTarget.submit()
  }

  csrfToken() {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    return metaTag ? metaTag.content : '';
  }
}
